<script setup>
import { computed, inject } from 'vue';
import { useWindowSize } from '@vueuse/core';

const props = defineProps({
  name: { type: String, required: true },
  chat: { type: Object, default: null },
  message: { type: Object, default: null },
  conversation: { type: Object, default: null },
});

const registry = inject('airjump-registry', {});
const { width } = useWindowSize();
const isMobile = computed(() => width.value < 768);

const widgets = computed(() => {
  const items = registry[props.name] || [];
  return items
    .filter(w => {
      if (w.mobile === false && isMobile.value) return false;
      if (w.mobile === 'only' && !isMobile.value) return false;
      return true;
    })
    .sort((a, b) => (a.order || 0) - (b.order || 0));
});
</script>

<template>
  <component
    v-for="(w, i) in widgets"
    :is="w.component"
    :key="`${name}-${i}`"
    v-bind="{ chat, message, conversation, ...(w.props || {}) }"
  />
</template>
